// Tabs/TabPanelContent.plants_varieties.tsx
import React from 'react';
import StrainsTable from '../components/tabs/plants_varieties/StrainsTable';
import StrainCard from '../components/tabs/plants_varieties/Strain';
import StrainsCompoundsConcentrations from '../components/tabs/plants_varieties/StrainCompoundsConcentrations';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentPlantsVarieties: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <StrainsTable header={'Varieties'} eventGroupToTrigger={'plants_varieties'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="plants_varieties" />
        </div>
        <div className="col-3 col-sm-3">
            <StrainCard header={'Variety'} eventGroupToTrigger={'plants_varieties'} />
            <StrainsCompoundsConcentrations header={'Concentration of terpenes in batch:'} eventGroupToTrigger={'plants_varieties'} />
        </div>
    </div>
);

export default TabPanelContentPlantsVarieties;
